import type { AppState } from '../types';

/** Estado vazio: só configuração. Tudo o mais vem da API (ver sync.ts). */
export function blankState(): AppState {
  return {
    v: 2,
    config: { digits: 5, order: 'rtl', onePerLead: true, burnCartela: true, sound: true, dramaticFinal: true },
    meta: { demo: false },
    missions: [], leads: [], cartelas: [], prizes: [], draws: [],
    events: [], ui: { activeEventId: null }
  };
}

/** Estados salvos por versões anteriores ganham sorteio e perdem o que migrou para a API. */
export function migrate(s: AppState): AppState {
  if (!s.meta) s.meta = { demo: false };
  if (!s.ui) s.ui = { activeEventId: null };
  if (!s.events) s.events = [];
  if (!s.prizes) s.prizes = [];
  if (!s.missions) s.missions = [];
  // v1 guardava regras e uma comunidade de exemplo no navegador; agora vêm da API
  const legacy = s as unknown as { rules?: unknown; v: number };
  if (legacy.rules || s.v < 2) { delete legacy.rules; s.leads = []; s.cartelas = []; s.draws = []; s.v = 2; }
  // versões antigas guardavam acessos por código no navegador; hoje vivem na API
  delete (s as { users?: unknown }).users;
  if (!s.ui.activeEventId && s.events[0]) s.ui.activeEventId = s.events[0].id;
  return s;
}
